import Button from "components/EvtKit/button/Button"
import Modal from "components/EvtKit/modal/Modal"
import BodyText from "components/Typography/BodyText"
import Heading from "components/Typography/Heading"
import AttentionIcon from "components/icons/AttentionIcon"
import styled from "styled-components"

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const ButtonContent = styled.div`
  display: flex;
  width: 160px;
`

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

const ButtonContainer = styled.div`
  justify-content: flex-end;
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 20px;
`

interface Props {
  planData: App.EventTypeMapper
  onConfirm: () => void
  onCancel: () => void
  loading: boolean
}

const UnpublishedEventTypeModal = (props: Props) => {
  const { planData, onConfirm, onCancel, loading } = props

  return (
    <Modal openModal={true} closeModal={onCancel} size="1-lg">
      <ModalContent>
        <IconContainer>
          <AttentionIcon />
          <Heading color="informative" variant="h4">
            Despublicar Tipo de Evento
          </Heading>
        </IconContainer>
        <Heading variant="h6">{planData.name}</Heading>
        <BodyText color="gray-dark" size="medium" weight="light" className="fill-width">
          A opção <b>'Não Publicado'</b> torna este <b>Tipo de Evento</b> indisponível no Plano, mas você pode
          republicá-lo a qualquer momento sem afetar os usuários que já o estão utilizando.
        </BodyText>
        <BodyText size="medium" weight="bold">
          Tem certeza de que deseja continuar com esta ação?
        </BodyText>
        <ButtonContainer>
          <ButtonContent>
            <Button label="Sim" className={`fill-width secondary-attention`} onClick={onConfirm} disabled={loading} />
          </ButtonContent>
          <ButtonContent>
            <Button label="Não" className={`fill-width attention-attention`} onClick={onCancel} disabled={loading} />
          </ButtonContent>
        </ButtonContainer>
      </ModalContent>
    </Modal>
  )
}

export default UnpublishedEventTypeModal
